export default [
  {
    path: "/preview/mttf/zx-to-mofang",
    name: "previewMttfZxToMofang",
    component: () => import("@/views/mttf/pages/zx-to-mofang/index.vue"),
    meta: {
      title: "赠转魔方数据统计",
    },
  },
  {
    path: "/preview/qdgl/channel-zzd-stats",
    name: "previewQdglChannelZzdStats",
    component: () => import("@/views/page/qdgl/channel-zzd-stats/index.vue"),
    meta: {
      title: "渠道管理-赠转短数据统计",
      newPage: true,
    },
  },
  // {
  //   path: "/preview/pdf-view",
  //   name: "previewPdfView",
  //   component: () => import("@/views/preview/pages/pdf-view/index.vue"),
  //   meta: {
  //     title: "文件预览",
  //     newPage: true,
  //   },
  // },
  
  {
    path: "/offline-refund/supplement-user-meta",
    name: "offlineRefundSupplementUserMeta",
    component: () => import("@/views/offline-refund/pages/supplement-user-meta/index.vue"),
  },
  {
    path: "/offline-refund/contract-down",
    name: "offlineRefundContractDown",
    component: () => import("@/views/offline-refund/pages/contract-down/index.vue"),
  },
  {
    path: "/offline-refund/contract-upload",
    name: "offlineRefundContractUpload",
    component: () => import("@/views/offline-refund/pages/contract-upload/index.vue"),
  },
];
